// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mt-1[data-v-335d2f14] {\n  margin-top: 6px;\n}\n.description[data-v-335d2f14] {\n  padding: 16px;\n  position: relative;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  color: #515a6e;\n  line-height: 1.5;\n  font-size: 14px;\n  border: 1px solid #abdcff;\n  background-color: #f0faff;\n}\n.iconfont[data-v-335d2f14] {\n  color: #06c05f;\n}\n[data-v-335d2f14] .el-tabs__nav-scroll {\n  margin-top: -10px;\n}\n", ""]);
// Exports
module.exports = exports;
